import React from 'react';
import BrowserFrame from './BrowserFrame';

const SaaSPlatform: React.FC = () => {
  const members = [
    { name: 'AM', color: 'var(--blue)' },
    { name: 'SK', color: 'var(--gold)' },
    { name: 'LF', color: '#5E35B1' },
    { name: 'TR', color: '#2E7D32' },
  ];

  return (
    <BrowserFrame url="miid.app/workspace" darkChrome>
      <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        {/* Sidebar */}
        <div style={{ background: '#0F2744', padding: '.8rem .5rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
          <div style={{ width: '32px', height: '32px', background: 'var(--gold)', color: '#0F2744', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, fontSize: '.85rem', borderRadius: '4px', margin: '0 auto .5rem' }}>M</div>
          {['▦', '◉', '◐', '⚙', '◈'].map((i, idx) => (
            <div key={idx} style={{
              width: '32px', height: '32px', margin: '0 auto',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: idx === 0 ? 'rgba(184,146,42,.15)' : 'transparent',
              color: idx === 0 ? 'var(--gold)' : 'rgba(255,255,255,.4)',
              fontSize: '.7rem', borderRadius: '4px',
            }}>
              {i}
            </div>
          ))}
        </div>

        {/* Main */}
        <div style={{ padding: '1rem', background: 'var(--cream)' }}>
          {/* Workspace switcher */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '.9rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', background: 'var(--white)', border: '1px solid var(--border)', padding: '.3rem .6rem', borderRadius: '4px' }}>
              <div style={{ width: '14px', height: '14px', background: 'linear-gradient(135deg, var(--blue), var(--gold))', borderRadius: '2px' }} />
              <div style={{ fontSize: '.6rem', fontWeight: 600, color: 'var(--ink)' }}>Acme Corp</div>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 4l3 3 3-3" stroke="currentColor" strokeWidth="1.3" /></svg>
            </div>
            {/* Members avatars */}
            <div style={{ display: 'flex' }}>
              {members.map((m, i) => (
                <div key={i} style={{
                  width: '22px', height: '22px', borderRadius: '50%', background: m.color,
                  color: 'white', fontSize: '.5rem', fontWeight: 700,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: '2px solid var(--white)', marginLeft: i > 0 ? '-6px' : 0,
                  fontFamily: "'Montserrat', sans-serif",
                }}>
                  {m.name}
                </div>
              ))}
              <div style={{
                width: '22px', height: '22px', borderRadius: '50%', background: 'var(--blue-pale)',
                color: 'var(--blue)', fontSize: '.5rem', fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                border: '2px solid var(--white)', marginLeft: '-6px',
              }}>+12</div>
            </div>
          </div>

          {/* KPI cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '.5rem', marginBottom: '.8rem' }}>
            {[
              { label: 'MRR', value: '€24.8k', trend: '+12%' },
              { label: 'Utilisateurs', value: '1 847', trend: '+8%' },
              { label: 'Churn', value: '2.1%', trend: '-0.4%' },
            ].map((k) => (
              <div key={k.label} style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.5rem .6rem', borderRadius: '4px' }}>
                <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase' }}>{k.label}</div>
                <div style={{ fontSize: '.85rem', fontWeight: 700, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif", lineHeight: 1.1 }}>{k.value}</div>
                <div style={{ fontSize: '.45rem', color: '#2E7D32', fontWeight: 600 }}>▲ {k.trend}</div>
              </div>
            ))}
          </div>

          {/* Billing card */}
          <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '4px', padding: '.65rem .75rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '.4rem' }}>
              <div>
                <div style={{ fontSize: '.5rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase' }}>Plan Business</div>
                <div style={{ fontSize: '.7rem', fontWeight: 700, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif" }}>€ 249 / mois</div>
              </div>
              <div style={{ padding: '.15rem .4rem', background: 'rgba(46,125,50,.12)', color: '#2E7D32', fontSize: '.45rem', fontWeight: 700, letterSpacing: '.1em', borderRadius: '2px' }}>ACTIF</div>
            </div>
            <div style={{ height: '4px', background: 'var(--blue-pale)', borderRadius: '2px', overflow: 'hidden' }}>
              <div style={{ width: '68%', height: '100%', background: 'linear-gradient(90deg, var(--blue), var(--gold))' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.25rem', fontSize: '.45rem', color: 'var(--ink2)' }}>
              <span>680 / 1000 seats</span>
              <span>Renouv. dans 12 j</span>
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default SaaSPlatform;
